import React, { useEffect, useState } from 'react';
import SurveyForm from './form';
import { useParams } from 'react-router-dom';
import Loading from '../../components/general/loading/loading';
import { asyncGetSurvey } from '../../../services/survey.service';

const SurveyEdit = () => {
    const { idSurvey } = useParams();
    const [row, setRow] = useState<any>(undefined);
    const [loading, setLoading] = useState<boolean>(true);
    const [save, setSave] = useState<boolean>(false);

    useEffect(() => {
        if (row === undefined || save) {
            asyncGetSurvey(idSurvey).then((body: any) => {
                if (body.items !== undefined) {
                    setRow(body.items);
                    setLoading(false);
                }
            });
        }
    }, [idSurvey, row, save]);

    return loading ? (
        <Loading />
    ) : (
        <SurveyForm
            idSurvey={idSurvey}
            surveyInfo={row}
            onSave={(value: any) => setSave(value)}
        />
    );
};

export default SurveyEdit;
